// extracted by mini-css-extract-plugin
module.exports = {"form":"NewCommentForm_form__gkKtQ","loading":"NewCommentForm_loading__3Inhc","control":"NewCommentForm_control__9CQgG","actions":"NewCommentForm_actions__2DULk"};